import AxiosControl from '../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getWorkOrders = (page = null, limit = null, search = '', sort = 'date', order = 'desc') => async (dispatch) => {
    dispatch({
        type: 'WORKORDER_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/workorder/getall/', { page, limit, search, sort, order, dateFrom: null, dateTo: null }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'WORKORDER_GETALL_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'WORKORDER_EDIT_SUCCESS',
                payload: data.workOrder
            })
        }
    } catch (error) {
        dispatch({
            type: 'WORKORDER_NOT_LOADING'
        })
    }
}

export const getWorkOrder = (workOrder) => async (dispatch) => {
    dispatch({
        type: 'WORKORDER_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/workorder/get/'+ workOrder, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'WORKORDER_GET_SUCCESS',
                payload: data.workOrder
            })
        }
    } catch (error) {
        dispatch({
            type: 'WORKORDER_NOT_LOADING'
        })
    }
}

export const addWorkOrder = (workOrderdata) => async (dispatch) => {
    dispatch({
        type: 'WORKORDER_LOADING'
    })
    try {
        const { data, status} = await Axios.post('/api/workorder/register', workOrderdata, {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'WORKORDER_ADD_SUCCESS',
                payload: data
            })
        }
        if (status === 265) {
            dispatch({
                type: 'WORKORDER_DUPLICATED',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'WORKORDER_NOT_LOADING'
        })
    }
}

export const editWorkOrder = (workOrderdata, idWorkOrder) => async (dispatch) => {
    try {
        const { data, status} = await Axios.put('/api/workorder/edit/' + idWorkOrder, workOrderdata, {
                headers: {
                    auth: localStorage.getItem('jwt')
                }
            }
        )
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'WORKORDER_EDIT_SUCCESS',
                payload: data
            })
        }
        if (status === 265) {
            dispatch({
                type: 'WORKORDER_DUPLICATED',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'WORKORDER_ERROR'
        })
    }
}

export const duplicateWorkOrder = (workOrderId) => async (dispatch) => {
    dispatch({
        type: 'WORKORDER_LOADING'
    })
    try {
        const { data, status} = await Axios.post('/api/workorder/duplicate/' + workOrderId, {}, {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'WORKORDER_DUPLICATE_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'WORKORDER_NOT_LOADING'
        })
    }
}

export const getLastNumWorkOrder = (year) => async (dispatch) => {
    try {
        const { data, status } = await Axios.get('/api/workOrder/getlastnumworkOrder', {
            headers: { auth: localStorage.getItem('jwt') },
            params: {year}
        })
        if (status === 200) {
            dispatch({
                type: 'NUM_WORKORDER_GET_SUCCESS',
                payload: data.numWorkOrder
            })
        }
    } catch (error) {
        dispatch({
            type: 'WORKORDER_NOT_LOADING'
        })
    }
}

export const removeWorkOrder = (workOrder) => async (dispatch) => {
    try {
        const { data, status } = await Axios.delete('/api/workorder/remove/' + workOrder, {
            headers: {
                auth: localStorage.getItem('jwt')
            }
        })
        if (status === 200 || status === 263) {
            dispatch({
                type: 'WORKORDER_REMOVE_RESULT',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'WORKORDER_NOT_LOADING'
        })
    }
}

export const resetWorkOrder = () => async (dispatch) => {
    dispatch({
        type: 'WORKORDERS_RESET'
    })
}

export const getWorkOrdersCalendar = (dateFrom, dateTo) => async (dispatch) => {
    try {
        const { data, status } = await Axios.post('/api/workorder/getall/',
            {
                page: 1,
                limit: 1000,
                search: '',
                dateFrom,
                dateTo
            },
            {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )

        if (status === 200) {
            dispatch({
                type: 'WORKORDER_GETALL_CALENDAR_SUCCESS',
                payload: data.workOrders
            })
        }
    } catch (error) {
        dispatch({
            type: 'WORKORDER_NOT_LOADING'
        })
    }
}
